import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FinalCtaNepean() {
  return <section data-section-id="261807" id="final-cta-nepean" className="relative overflow-hidden bg-background py-32 text-foreground">
      {}
      <div className="pointer-events-none absolute bottom-[-20%] left-1/2 h-[400px] w-[80%] max-w-[1000px] -translate-x-1/2 bg-secondary opacity-20 blur-[120px]" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 text-center">
        <div className="mx-auto max-w-3xl">
          <h2 className="font-default mb-6 text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl">
            Ready to Remove
            <br />
            Your Junk?
          </h2>
          
          <p className="mb-10 text-lg text-muted-foreground sm:text-xl">
            Book fast affordable junk removal in Nepean today.
          </p>
          
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="h-12 border-none bg-secondary px-8 text-base font-semibold text-secondary-foreground shadow-lg shadow-secondary/20 transition-all hover:bg-secondary/90 hover:shadow-secondary/40 rounded-lg">
              <Link to="/PricingPage">Get a Quote</Link>
            </Button>
            
            {}
            <Button asChild size="lg" variant="outline" className="h-12 border-none bg-secondary px-8 text-base font-semibold text-secondary-foreground shadow-lg shadow-secondary/20 transition-all hover:bg-secondary/90 hover:text-secondary-foreground hover:shadow-secondary/40 rounded-lg">
              <Link to="/AboutPage">Learn More</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}